// Yaml Files
import aboutYaml from '../../ids-about/demos/index.yaml';
import avatarYaml from '../../ids-avatar/demos/index.yaml';
import accordionYaml from '../../ids-accordion/demos/index.yaml';
import actionPanelYaml from '../../ids-action-panel/demos/index.yaml';
import actionSheetYaml from '../../ids-action-sheet/demos/index.yaml';
import alertYaml from '../../ids-alert/demos/index.yaml';
import appMenuYaml from '../../ids-app-menu/demos/index.yaml';
import areaChartYaml from '../../ids-area-chart/demos/index.yaml';
import axisChartYaml from '../../ids-axis-chart/demos/index.yaml';
import badgeYaml from '../../ids-badge/demos/index.yaml';
import barChartYaml from '../../ids-bar-chart/demos/index.yaml';
import blockGridYaml from '../../ids-block-grid/demos/index.yaml';
import boxYaml from '../../ids-box/demos/index.yaml';
import breadcrumbYaml from '../../ids-breadcrumb/demos/index.yaml';
import buttonYaml from '../../ids-button/demos/index.yaml';
import calendarYaml from '../../ids-calendar/demos/index.yaml';
import cardYaml from '../../ids-card/demos/index.yaml';
import checkboxYaml from '../../ids-checkbox/demos/index.yaml';
import colorYaml from '../../ids-color/demos/index.yaml';
import colorPickerYaml from '../../ids-color-picker/demos/index.yaml';
import containerYaml from '../../ids-container/demos/index.yaml';
import countsYaml from '../../ids-counts/demos/index.yaml';
import dataGridYaml from '../../ids-data-grid/demos/index.yaml';
import dataLabelYaml from '../../ids-data-label/demos/index.yaml';
import datePickerYaml from '../../ids-date-picker/demos/index.yaml';
import draggableYaml from '../../ids-draggable/demos/index.yaml';
import drawerYaml from '../../ids-drawer/demos/index.yaml';
import dropdownYaml from '../../ids-dropdown/demos/index.yaml';
import editorYaml from '../../ids-editor/demos/index.yaml';
import emptyMessageYaml from '../../ids-empty-message/demos/index.yaml';
import errorPageYaml from '../../ids-error-page/demos/index.yaml';
import expandableAreaYaml from '../../ids-expandable-area/demos/index.yaml';
import fieldsetYaml from '../../ids-fieldset/demos/index.yaml';
import filterFieldYaml from '../../ids-filter-field/demos/index.yaml';
import formYaml from '../../ids-form/demos/index.yaml';
import formLayoutYaml from '../../ids-form-layout/demos/index.yaml';
import headerYaml from '../../ids-header/demos/index.yaml';
import hiddenYaml from '../../ids-hidden/demos/index.yaml';
import hierarchyYaml from '../../ids-hierarchy/demos/index.yaml';
import homePageYaml from '../../ids-home-page/demos/index.yaml';
import hyperlinkYaml from '../../ids-hyperlink/demos/index.yaml';
import idsGlobalYaml from '../../ids-global/demos/index.yaml';
import iconYaml from '../../ids-icon/demos/index.yaml';
import imageYaml from '../../ids-image/demos/index.yaml';
import inputYaml from '../../ids-input/demos/index.yaml';
import inputGroupYaml from '../../ids-input-group/demos/index.yaml';
import kpiYaml from '../../ids-kpi/demos/index.yaml';
import layoutFlexYaml from '../../ids-layout-flex/demos/index.yaml';
import layoutGridYaml from '../../ids-layout-grid/demos/index.yaml';
import lineChartYaml from '../../ids-line-chart/demos/index.yaml';
import listBoxYaml from '../../ids-list-box/demos/index.yaml';
import listBuilderYaml from '../../ids-list-builder/demos/index.yaml';
import listViewYaml from '../../ids-list-view/demos/index.yaml';
import loadingIndicatorYaml from '../../ids-loading-indicator/demos/index.yaml';
import localeYaml from '../../ids-locale/demos/index.yaml';
import lookupYaml from '../../ids-lookup/demos/index.yaml';
import maskYaml from '../../ids-mask/demos/index.yaml';
import mastheadYaml from '../../ids-masthead/demos/index.yaml';
import mediaGalleryYaml from '../../ids-media-gallery/demos/index.yaml';
import menuYaml from '../../ids-menu/demos/index.yaml';
import menuButtonYaml from '../../ids-menu-button/demos/index.yaml';
import messageYaml from '../../ids-message/demos/index.yaml';
import modalYaml from '../../ids-modal/demos/index.yaml';
import moduleNavYaml from '../../ids-module-nav/demos/index.yaml';
import monthViewYaml from '../../ids-month-view/demos/index.yaml';
import multiselectYaml from '../../ids-multiselect/demos/index.yaml';
import notificationBannerYaml from '../../ids-notification-banner/demos/index.yaml';
import pagerYaml from '../../ids-pager/demos/index.yaml';
import pageExamplesYaml from '../../ids-page-examples/demos/index.yaml';
import personalizeYaml from '../../ids-personalize/demos/index.yaml';
import pieChartYaml from '../../ids-pie-chart/demos/index.yaml';
import popupYaml from '../../ids-popup/demos/index.yaml';
import popupMenuYaml from '../../ids-popup-menu/demos/index.yaml';
import processIndicatorYaml from '../../ids-process-indicator/demos/index.yaml';
import progressBarYaml from '../../ids-progress-bar/demos/index.yaml';
import progressChartYaml from '../../ids-progress-chart/demos/index.yaml';
import radarYaml from '../../ids-radar-chart/demos/index.yaml';
import radioYaml from '../../ids-radio/demos/index.yaml';
import ratingYaml from '../../ids-rating/demos/index.yaml';
import scrollViewYaml from '../../ids-scroll-view/demos/index.yaml';
import searchFieldYaml from '../../ids-search-field/demos/index.yaml';
import segmentedControlYaml from '../../ids-segmented-control/demos/index.yaml';
import separatorYaml from '../../ids-separator/demos/index.yaml';
import skipLinkYaml from '../../ids-skip-link/demos/index.yaml';
import sliderYaml from '../../ids-slider/demos/index.yaml';
import spinboxYaml from '../../ids-spinbox/demos/index.yaml';
import splitterYaml from '../../ids-splitter/demos/index.yaml';
import statsYaml from '../../ids-stats/demos/index.yaml';
import stepChartYaml from '../../ids-step-chart/demos/index.yaml';
import swappableYaml from '../../ids-swappable/demos/index.yaml';
import swaplistYaml from '../../ids-swaplist/demos/index.yaml';
import swipeActionYaml from '../../ids-swipe-action/demos/index.yaml';
import switchYaml from '../../ids-switch/demos/index.yaml';
import tabsYaml from '../../ids-tabs/demos/index.yaml';
import tagYaml from '../../ids-tag/demos/index.yaml';
import textYaml from '../../ids-text/demos/index.yaml';
import textareaYaml from '../../ids-textarea/demos/index.yaml';
import themeSwitcherYaml from '../../ids-theme-switcher/demos/index.yaml';
import timePickerYaml from '../../ids-time-picker/demos/index.yaml';
import toastYaml from '../../ids-toast/demos/index.yaml';
import toggleButtonYaml from '../../ids-toggle-button/demos/index.yaml';
import toolbarYaml from '../../ids-toolbar/demos/index.yaml';
import tooltipYaml from '../../ids-tooltip/demos/index.yaml';
import treeYaml from '../../ids-tree/demos/index.yaml';
import treemapYaml from '../../ids-treemap/demos/index.yaml';
import triggerFieldYaml from '../../ids-trigger-field/demos/index.yaml';
import uploadAdvancedYaml from '../../ids-upload-advanced/demos/index.yaml';
import uploadYaml from '../../ids-upload/demos/index.yaml';
import virtualScrollYaml from '../../ids-virtual-scroll/demos/index.yaml';
import weekViewYaml from '../../ids-week-view/demos/index.yaml';
import widgetYaml from '../../ids-widget/demos/index.yaml';
import wizardYaml from '../../ids-wizard/demos/index.yaml';

const categories: Array<any> = [
  { name: 'Form Inputs', icon: 'display', components: [] },
  { name: 'Navigation and Interaction', icon: 'map', components: [] },
  { name: 'Messages and Alerts', icon: 'success', components: [] },
  { name: 'Lists', icon: 'spreadsheet', components: [] },
  { name: 'Layouts', icon: 'project', components: [] },
  { name: 'Patterns', icon: 'design-mode', components: [] },
  { name: 'Charts and Visualizations', icon: 'line-bar-chart', components: [] },
  { name: 'Typography', icon: '', components: [] },
];

const addYaml = (yaml: any) => {
  const index = categories.findIndex((element: any) => element.name === yaml.category);
  categories[index].components.push(yaml);
};

// Add each yaml file
addYaml(accordionYaml);
addYaml(actionSheetYaml);
addYaml(aboutYaml);
addYaml(avatarYaml);
addYaml(alertYaml);
addYaml(areaChartYaml);
addYaml(axisChartYaml);
addYaml(appMenuYaml);
addYaml(badgeYaml);
addYaml(barChartYaml);
addYaml(blockGridYaml);
addYaml(boxYaml);
addYaml(breadcrumbYaml);
addYaml(buttonYaml);
addYaml(calendarYaml);
addYaml(cardYaml);
addYaml(checkboxYaml);
addYaml(colorYaml);
addYaml(colorPickerYaml);
addYaml(containerYaml);
addYaml(countsYaml);
addYaml(actionPanelYaml);
addYaml(dataGridYaml);
addYaml(dataLabelYaml);
addYaml(datePickerYaml);
addYaml(draggableYaml);
addYaml(drawerYaml);
addYaml(dropdownYaml);
addYaml(editorYaml);
addYaml(emptyMessageYaml);
addYaml(errorPageYaml);
addYaml(expandableAreaYaml);
addYaml(fieldsetYaml);
addYaml(filterFieldYaml);
addYaml(formYaml);
addYaml(formLayoutYaml);
addYaml(headerYaml);
addYaml(hiddenYaml);
addYaml(hierarchyYaml);
addYaml(homePageYaml);
addYaml(hyperlinkYaml);
addYaml(idsGlobalYaml);
addYaml(iconYaml);
addYaml(inputYaml);
addYaml(inputGroupYaml);
addYaml(imageYaml);
addYaml(kpiYaml);
addYaml(layoutFlexYaml);
addYaml(layoutGridYaml);
addYaml(localeYaml);
addYaml(lineChartYaml);
addYaml(listBoxYaml);
addYaml(listBuilderYaml);
addYaml(listViewYaml);
addYaml(loadingIndicatorYaml);
addYaml(lookupYaml);
addYaml(maskYaml);
addYaml(mastheadYaml);
addYaml(mediaGalleryYaml);
addYaml(menuYaml);
addYaml(menuButtonYaml);
addYaml(messageYaml);
addYaml(modalYaml);
addYaml(moduleNavYaml);
addYaml(monthViewYaml);
addYaml(multiselectYaml);
addYaml(notificationBannerYaml);
addYaml(pagerYaml);
addYaml(pageExamplesYaml);
addYaml(personalizeYaml);
addYaml(pieChartYaml);
addYaml(popupYaml);
addYaml(popupMenuYaml);
addYaml(processIndicatorYaml);
addYaml(progressBarYaml);
addYaml(progressChartYaml);
addYaml(radarYaml);
addYaml(radioYaml);
addYaml(ratingYaml);
addYaml(scrollViewYaml);
addYaml(searchFieldYaml);
addYaml(segmentedControlYaml);
addYaml(separatorYaml);
addYaml(skipLinkYaml);
addYaml(sliderYaml);
addYaml(splitterYaml);
addYaml(spinboxYaml);
addYaml(statsYaml);
addYaml(stepChartYaml);
addYaml(swappableYaml);
addYaml(swaplistYaml);
addYaml(swipeActionYaml);
addYaml(switchYaml);
addYaml(tabsYaml);
addYaml(tagYaml);
addYaml(textYaml);
addYaml(textareaYaml);
addYaml(themeSwitcherYaml);
addYaml(timePickerYaml);
addYaml(toggleButtonYaml);
addYaml(toolbarYaml);
addYaml(tooltipYaml);
addYaml(toastYaml);
addYaml(treeYaml);
addYaml(treemapYaml);
addYaml(triggerFieldYaml);
addYaml(uploadYaml);
addYaml(uploadAdvancedYaml);
addYaml(virtualScrollYaml);
addYaml(wizardYaml);
addYaml(widgetYaml);
addYaml(weekViewYaml);

let html = '';
categories.forEach((category: any) => {
  html += `<ids-text type="h1" font-size="24">${category.name}</ids-text>
  <ids-layout-grid auto-fit="true" justify-content="start" padding-y="md"><ids-layout-grid-cell><ids-block-grid align="center">`;
  category.components.forEach((component: any) => {
    html += `<ids-block-grid-item><ids-card actionable="true" shadowed height="100" href="/${component.link}" target="_self"><div slot="card-content">
    <ids-text type="h2" font-size="16" font-weight="semi-bold" color="text-default">${component.component}</ids-text>
    <ids-text type="h2" font-size="16" color="text-subtle">${component.description}</ids-text>
    </div></ids-card></ids-block-grid-item>
    `;
  });
  html += `</ids-block-grid></ids-layout-grid-cell></ids-layout-grid>`;
});
document.querySelector('#dynamic-area')?.insertAdjacentHTML('afterbegin', html);

// Handle Clicking Links
document.addEventListener('click', (event: any) => {
  const target = event.target.closest('[slot="card-content"]');
  if (target) {
    window.location.href = `/${target.getAttribute('link')}`;
  }
});
